import { decode } from "@gandlaf21/bolt11-decode";
import { Cubby } from "../stores/Cubby";
import {
  buildInboundPaymentMessage,
  buildLedgerInboundPaymentMessage,
  extractSenderMessage,
} from "./events";
import _ from "lodash";
import * as Sentry from "@sentry/react";

export const ledgerEntries = (cubby: Cubby, limit: number) => {
  const acc = [];
  // confirmedAtUnixtime, numSats (neg or positive), message

  // console.log(cubby.payOffchainEvents.data);
  for (const payOffChainEvent of cubby.payOffchainEvents.data) {
    //console.log(payOffChainEvent);
    const hash = {};
    hash["id"] = payOffChainEvent.event.id;

    // Parse confirmedAtUnixtime
    const confirmedAt = payOffChainEvent.event.confirmed_at;
    if (confirmedAt) {
      hash["confirmedAtUnixtime"] = new Date(confirmedAt).getTime();
    } else {
      //console.warn("Missing confirmed_at for event", payOffChainEvent.event.id);
      hash["confirmedAtUnixtime"] = null;
    }

    // Default values for tokens and fee
    hash["tokens"] = null;
    hash["fee"] = null;

    // Handle confirmed events
    if (payOffChainEvent.eventKind === "confirmed") {
      // Calculate tokens
      if (
        payOffChainEvent.event.tokens !== undefined &&
        payOffChainEvent.event.tokens !== null
      ) {
        hash["tokens"] = payOffChainEvent.event.tokens * -1;
      } else {
        // console.warn("Missing tokens for event", payOffChainEvent.event.id);
      }

      // Handle request and decode invoice
      if (payOffChainEvent.event?.request) {
        try {
          const decodedInvoice = decode(payOffChainEvent.event.request);
          // console.log("Decoded invoice:", decodedInvoice);

          // Extract message from invoice description
          const descriptionSection = decodedInvoice.sections.find(
            (section) => section.name === "description"
          );
          if (descriptionSection?.value?.length > 0) {
            // console.log("description found:", descriptionSection.value);
            hash["message"] = descriptionSection.value;
          } else {
            hash["message"] = null;
          }

          // Calculate fee and adjust tokens
          const decodedInvoiceSize =
            decodedInvoice.sections.find((section) => section.name === "amount")
              ?.value / 1000;
          if (decodedInvoiceSize) {
            const calculatedFee =
              payOffChainEvent.event.tokens - decodedInvoiceSize;
            hash["tokens"] = decodedInvoiceSize * -1;
            hash["fee"] = calculatedFee;
          } else {
            // console.warn(
            //   "Missing amount in decoded invoice for event",
            //   payOffChainEvent.event.id
            // );
          }
        } catch (error) {
          console.error(
            "Failed to decode invoice for event",
            payOffChainEvent.event.id,
            error
          );
          Sentry.captureException(error, {
            tags: {
              function: "ledgerEntries",
              action: "decode_invoice",
            },
            contexts: {
              ledger_details: {
                eventId: payOffChainEvent.event.id,
                eventKind: payOffChainEvent.eventKind,
                hasRequest: !!payOffChainEvent.event?.request,
                request:
                  payOffChainEvent.event?.request?.substring(0, 100) || "", // First 100 chars only
                confirmedAt: payOffChainEvent.event.confirmed_at,
                tokens: payOffChainEvent.event.tokens,
                limit: limit,
              },
            },
          });
          hash["message"] = null;
        }
      } else {
        hash["message"] = null;
      }

      // console.log("Processed pay-offchain object:", hash);
      acc.push(hash);
    }
  }

  // console.log("all ledger data for payoffchain events", acc);

  // console.log(cubby.invoiceUpdateEvents.data);
  for (const invoiceUpdateEvent of cubby.invoiceUpdateEvents.data) {
    if (invoiceUpdateEvent.is_confirmed == true) {
      // console.log("invoiceUpdateEvent", invoiceUpdateEvent);
      const hash = {};
      hash["id"] = invoiceUpdateEvent.id;
      hash["tokens"] = invoiceUpdateEvent.received;
      hash["confirmedAtUnixtime"] = new Date(
        invoiceUpdateEvent.confirmed_at
      ).getTime();
      if (invoiceUpdateEvent.description.length > 0) {
        hash["message"] = buildLedgerInboundPaymentMessage(
          hash["tokens"],
          invoiceUpdateEvent.description
        );
      } else {
        const possibleKeysendMessage = extractSenderMessage(invoiceUpdateEvent);
        // console.log("possibleKeysendMessage", possibleKeysendMessage);
        if (possibleKeysendMessage.length > 0) {
          hash["message"] = possibleKeysendMessage;
        } else {
          hash["message"] = null;
        }
      }
      acc.push(hash);
    }
  }
  console.log(limit);
  const sortedData = _.orderBy(acc, ["confirmedAtUnixtime"], ["desc"]);
  const limitedData = _.take(sortedData, limit);
  return limitedData;
};
